export default __webpack_public_path__ + "static/media/IMG_0006_14_11zon.235ccdaa.jpg";